module.exports = __webpack_public_path__ + "static/media/img-1.8f030e49.jpg";